import React, { useMemo } from 'react';
import { Loader2 } from 'lucide-react';

import { MultiSelect } from 'shadcn/components/ui/MultiSelect';
import { cn } from 'shadcn/lib/utils';
import { useFbmAccountsQuery } from 'shared/hooks/fbm/useFbmAccountsQuery';

const DEFAULT_EXCLUDED_NAMES = ['gopuff', 'doordash', 'imperfect'];

function SourceSelector({
    allLabel = 'All Sources',
    className,
    excludedNames = DEFAULT_EXCLUDED_NAMES,
    label = 'Source',
    onChange,
    value,
}) {
    const { data: accounts = [], isPending } = useFbmAccountsQuery();

    const sourceOptions = useMemo(() => {
        const filteredAccounts = (accounts || []).filter((account) => !excludedNames.includes(account.fbmAccountName));
        return [{ fbmAccountName: 'MISFITS_MARKET', companyName: 'Misfits Market' }, ...filteredAccounts];
    }, [accounts, excludedNames]);

    const labelId = 'source-select-label';

    const accountOptions = useMemo(
        () =>
            sourceOptions.map((source) => ({
                value: source.fbmAccountName,
                label: source.companyName,
            })),
        [sourceOptions],
    );

    if (isPending) {
        return (
            <div className={cn('flex flex-col gap-2', className)}>
                <span
                    id={labelId}
                    className="text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground"
                >
                    {label}
                </span>
                <div className="flex h-10 w-full min-w-[200px] items-center justify-center gap-2 rounded-md border border-input bg-card px-3 text-muted-foreground">
                    <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
                    <span className="text-sm">Loading sources…</span>
                </div>
            </div>
        );
    }

    const placeholder = value.length === 0 ? allLabel : 'Select sources';

    return (
        <div className={cn('flex flex-col gap-2', className)}>
            <span
                id={labelId}
                className="text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground"
            >
                {label}
            </span>
            <MultiSelect
                aria-labelledby={labelId}
                className="min-w-[200px]"
                options={accountOptions}
                placeholder={placeholder}
                value={value}
                onValueChange={onChange}
            />
        </div>
    );
}

export { SourceSelector };
